import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';

import { QuillEditorComponent } from 'ngx-quill';

import 'quill-mention';

@Component({
  selector: 'app-textarea-tagging',
  templateUrl: './textarea-tagging.component.html',
  styleUrls: ['./textarea-tagging.component.scss'],
})
export class TextareaTaggingComponent implements OnInit {
  @Input() value: any;
  @Input() users: any;
  @Input() placeholder: any;
  @Output() valueChanged = new EventEmitter<any>();

  constructor() {}

  ngOnInit(): void {}

  @ViewChild(QuillEditorComponent, { static: true })
  editor: QuillEditorComponent;

  modules = {
    toolbar: false,
    mention: {
      mentionListClass: 'ql-mention-list mat-elevation-z8',
      allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
      showDenotationChar: false,
      spaceAfterInsert: false,
      source: (searchTerm, renderList) => {
        if (searchTerm.length === 0) {
          renderList(this.users, searchTerm);
        } else {
          const matches = [];
          this.users.forEach((entry) => {
            if (
              entry.value.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1
            ) {
              matches.push(entry);
            }
          });
          renderList(matches, searchTerm);
        }
      },
    },
  };

  onEditorChanged(event) {
    this.valueChanged.emit(event.html);
  }

  extractMentionsFromHTML(htmlContent) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlContent, 'text/html');
    const mentionElements = doc.querySelectorAll('.mention');
    const mentions = Array.from(mentionElements).map((mention) => ({
      id: mention.getAttribute('data-id'),
      value: mention.textContent,
    }));

    return mentions;
  }

  extractMentionsFromDelta(delta) {
    const mentions = [];
    delta.ops.forEach((op) => {
      if (op.insert && typeof op.insert === 'object' && op.insert.mention) {
        mentions.push(op.insert.mention);
      }
    });
    return mentions;
  }
}
